<!--
* UIID: UI-DLB-SRM-130
* UI Name: Add Reference File
* Modify Date: 2020/04/16
-->
<template>
  <dialog-drag
    :id="id"
    :ref='"dialog-" + id'
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title
        class="headline white--text px-0"
        primary-title
      >{{$t('lbl.srmListManagement.referenceFiles.page_header')}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon style="right: -16px" @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->
    <v-card-text class="info-section">
      <!-- [S]  Data Section-->
      <v-row class="ma-0">
        <v-col cols="12" sm="12" class="pa-0 pt-0">
          <span v-if="caller != 'repository'" class="float-left">
            <span
              class="subheader-text popup-sub-header-text"
            >{{this.options.item.SRM_SNDR}} - {{this.options.item.SRM_RCVR}} -</span>
            <span class="subheader-message">{{this.options.item.SRM_MSG_ID}}</span>
          </span>
          <span v-if="caller == 'repository'" class="float-left">
            <span
              class="subheader-text popup-sub-header-text"
            >{{this.options.item.REPO_SNDR}} - {{this.options.item.REPO_RCVR}} -</span>
            <span class="subheader-message">{{this.options.item.REPO_MSG_ID}}</span>
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text class="reference-data-section pa-0 pr-8 pl-8 mb-2">
      <v-row class="ma-0 padding-bottom-10">
        <v-col cols="12" class="pt-0 pr-0 pb-0 pl-0">
          <v-data-table
            :headers="SummDataList.headers"
            :items="dataItems"
            :hide-default-footer="true"
            :disable-sort="true"
            class="add-reference-table pb-0"
            fixed-header
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="document-type-col">
                    <v-select
                      :items="documentType"
                      @click="onClickDocumentType(item)"
                      @change="onChangeDocumentType(item)"
                      v-model="item.ATF_FRMT_TP"
                      class="data-table-select-box custom-selectbox input-no-wrap-text"
                      height="16"
                      hide-details
                      outlined
                      dense
                    ></v-select>
                  </td>
                  <td class="file-name-col">
                    <v-text-field
                      :value="item.ATF_FILE_NAME"
                      class="data-table-filter-text-field search-button-data-analysis-table"
                      heigth="30"
                      outlined
                      hide-details
                      dense
                      solo
                    ></v-text-field>
                  </td>
                  <td class="updated-date-col">{{ item.ATF_UPD_DT}}</td>
                  <td class="manage-col text-right">
                    <!-- <v-btn v-if="checkPdfExtension(item)" small text icon>
                      <v-icon
                        color="manager-col-preview darken-1"
                        small
                        @click="previewPDFFile(item)"
                      >fas fa-search-plus</v-icon>
                    </v-btn> -->
                    <v-btn small text icon @click="downloadReferenceFile(item)">
                      <v-icon color="manager-col-down darken-1" small>far fa-arrow-alt-circle-down</v-icon>
                    </v-btn>
                    <v-btn small text icon @click="deleteRow(item)">
                      <v-icon color="popup-col-delete darken-1" small>far fa-trash-alt</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="6" class="pa-0">
          <input type="file" ref="file" style="display: none" @change="browersReferenceFile()" />
          <v-btn
            @click="$refs.file.click()"
            class="ma-0 btn-add-reference-style btn-search primary"
            tile
            dark
          >{{$t('btn.srmListManagement.browse')}}</v-btn>
          <v-btn
            @click="openReferenceList()"
            class="ma-0 ml-2 btn-add-reference-style btn-search primary"
            tile
            dark
          >{{$t('btn.common.load')}}</v-btn>
        </v-col>
        <v-col class="pa-0 text-right" cols="6">
          <v-btn
            @click="saveReferenceFile"
            :disabled="isEnableSave"
            class="ma-0 btn-add-reference-style btn-search primary"
            tile
            dark
          >{{$t('btn.common.save')}}</v-btn>
        </v-col>
      </v-row>
      <!-- [E]  Data section-->
    </v-card-text>
    <v-row class="ma-0 pt-0">
      <v-col class="pa-0 text-left" cols="3"></v-col>
      <v-col class="pa-0" cols="9">
        <v-row class="ma-0">
          <v-spacer></v-spacer>
          <v-col class="pa-0 text-right" cols="6">
            <v-btn class="ma-0 btn-style btn-delete" tile dark @click="removeDialog">
              <!-- <v-icon small color="white" class="mr-1">fa fa-times</v-icon> -->
              {{$t('btn.common.close')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- <v-dialog v-model="pdfDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>View Pdf File</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="pdfDialog = false">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <pdf :url="pdfUrl" />
      </v-card>
    </v-dialog> -->
    <dialogWindow
      ref="successDialog"
      size="max"
      title="Success"
      color="success"
      detail="Success to change reference file"
      @select-ok="removeDialog"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
import { mapState } from "vuex";
import IconSvg from "@/vue-caas/components/IconBase.vue";
// import pdf from '../../components/pdf-viewer/pdf.vue'

// import {
//   showSuccessMessage,
//   showErrorMessage,
//   showProgress,
//   hideProgress,
//   alertSuccess,
//   closeAlert
// } from "@/vue-dlb/utils/sys-util.js";


export default {
  components: {
    DialogDrag,
    // pdf,
    dialogWindow,
    IconSvg
  },
  name: 'add-reference-dialog',
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd', 'queryList', 'caller'],
  props:{
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    queryList: Function,
    caller: String
  },
  computed: {
    ...mapState("common", {
      bizCodeList: "bizCodeList",
      codeList: "codeList"
    }),
    ...mapState("srmlist", {
      atftList: "atftList"
    }),
    isEnableSave(){
      if(this.referenceSaveItemsParams.data.length > 0 || this.flagSave){
        return false;
      }
      return true;
    }
  },
  data(){
    return{
    SummDataList: {
      headers: [
        { text: 'Document Type', value: 'ATF_FRMT_TP', width: '200px' },
        { text: 'File Name', value: 'ATF_FILE_NAME' },
        { text: 'Updated Date', value: 'ATF_UPD_DT', width: '170px' },
        { text: 'Manage', value: 'ATF_FILE_PATH', width: '150px' },
      ]
    },
    ReferenceDataList: {
    header: ['SYSSTATUS','ADDBY','CUST_ID','USER_ID','ATF_PRCS_NO','SRM_PRCS_NO','ATF_FILE_NAME','FILE_ID','ATF_FILE_SIZE','file'],
      data: [{
        SYSSTATUS: '',
        ADDBY: '',
        CUST_ID: '',
        USER_ID: '',
        ATF_PRCS_NO: '',
        SRM_PRCS_NO: '',
        ATF_FILE_NAME: '',
        FILE_ID: '',
        ATF_FILE_SIZE: '',
        file:''
      }]
    },
    dialog: false,
    reloadPage: false,
    dialogs: [],
    dialogId:1,
    // pdfDialog: false,
    // pdfUrl :'1.pdf',
    arrLayoutDialog: [],
    selected: null,
    dataItems: [],
    oldItem: '',
    flagSave: false,
    masterSearchItems: {
      header: ['SRM_PRCS_NO'],
      data: [{
        SRM_PRCS_NO: '',
      }],
    },
    masterSearchItemsRepo: {
      header: ['REPO_PRCS_NO'],
      data: [{
        REPO_PRCS_NO: '',
      }],
    },
    referenceDownloadItems: {
      header: ['FILE_ID','SAVE_NAME'],
      data: [{
        FILE_ID: '',
        SAVE_NAME:''
      }],
    },
    referenceSaveItemsParams:{
      header: ['SYSSTATUS','ADDBY','CUST_ID', 'OWNR_CUST_ID', 'USER_ID','ATF_PRCS_NO','SRM_PRCS_NO','ATF_FRMT_TP','ATF_FILE_NAME','FILE_ID','ATF_FILE_SIZE','file'],
      data:[],
    },
    // referenceSaveItems:{
    //   header: ['SYSSTATUS','ADDBY','CUST_ID','USER_ID','ATF_PRCS_NO','SRM_PRCS_NO','ATF_FRMT_TP','ATF_FILE_NAME','FILE_ID','ATF_FILE_SIZE','file'],
    //   data:[{
    //      SYSSTATUS:'',
    //      ADDBY:'',
    //      CUST_ID:'',
    //      USER_ID:'',
    //      ATF_PRCS_NO:'',
    //      SRM_PRCS_NO:'',
    //      ATF_FRMT_TP:'',
    //      ATF_FILE_NAME:'',
    //      FILE_ID:'',
    //      ATF_FILE_SIZE:'',
    //      file:'',
    //    }],
    // },
    referenceModifyItemsParams: {
      header: ['ATF_PRCS_NO','FRMT_TP','CHKIN_COMT'],
      data:[]
    },
    documentType: [],
    codeSearchItems: {
      header: ['GRP_CODE'],
      data: [{
        GRP_CODE:'',
      }],
    },
  }},

  methods: {
    //[2020-10-09] apply by CLV: check documentType Change
    onClickDocumentType(item){
      this.oldItem = item.ATF_FRMT_TP;
    },
    //[2020-10-09] apply by CLV: check documentType Change
    onChangeDocumentType(item){
      if (item.ATF_FRMT_TP != this.oldItem){
        this.flagSave = true;
        let params = {};
        params.ATF_PRCS_NO = item.ATF_PRCS_NO;
        params.FRMT_TP =item.ATF_FRMT_TP;
        params.CHKIN_COMT = item.CHKIN_COMT;
        this.referenceModifyItemsParams.data.push(params);
      }
    },
    queryReferenceFilesList () {

      //[2020-04-17] apply by CLV: Apply srmlist/queryReferenceFilesList api
      console.log("--------- getSummaryList ----------");
      let searchItem = {};
      if (this.caller == 'repository') {
        this.masterSearchItemsRepo.data[0].REPO_PRCS_NO = this.options.item.REPO_PRCS_NO;
        searchItem = this.masterSearchItemsRepo;
      } else {
        this.masterSearchItems.data[0].SRM_PRCS_NO = this.options.item.SRM_PRCS_NO;
        searchItem = this.masterSearchItems;
      }

      Store.dispatch("srmlist/queryReferenceFilesList", searchItem).then(() => {
        console.log("--------- Finished to process ----------");
        console.log(this.atftList);
        this.dataItems = this.atftList;
      });
    },
    getCode(){
      this.codeSearchItems.data[0].GRP_CODE ="B05";
      Store.dispatch("common/getCode", this.codeSearchItems).then(() => {
        console.log("--------- Finished to process code List ----------");
        for(let i=0;i< this.codeList.length;i++){
        let codeObj= {};
        codeObj.text= this.codeList[i].CM_CODE_NAME;
        codeObj.value= this.codeList[i].CM_CODE_ID;
        this.documentType.push(codeObj);
        }
      });
    },
    removeDialog (dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      if (this.reloadPage) {
        this.$emit("reloadPage");
      }
    },
    selectDialog (obj) {
      this.dragStart(obj);
    },
    dialogDragEnd (obj) {
        this.dragEnd(obj);
    },
    addreferenceFileRow(referenceFilesItems){
      let {referenceList, selectItem} = referenceFilesItems;
      let addReferenceDataRow = {};
      addReferenceDataRow.ATF_FILE_NAME =referenceList.ATF_FILE_NAME;
      addReferenceDataRow.SYSSTATUS = referenceList.SYSSTATUS;
      addReferenceDataRow.ADDBY = referenceList.ADDBY;
      addReferenceDataRow.CUST_ID = referenceList.CUST_ID;
      addReferenceDataRow.OWNR_CUST_ID = referenceList.OWNR_CUST_ID;
      addReferenceDataRow.USER_ID = referenceList.USER_ID;
      addReferenceDataRow.ATF_PRCS_NO = referenceList.ATF_PRCS_NO
      if (this.caller == 'repository') {
        addReferenceDataRow.SRM_PRCS_NO = this.options.item.REPO_PRCS_NO;
      }else{
        addReferenceDataRow.SRM_PRCS_NO = this.options.item.SRM_PRCS_NO;
      }
      addReferenceDataRow.ATF_FRMT_TP =referenceList.ATF_FRMT_TP
      addReferenceDataRow.FILE_ID = referenceList.FILE_ID
      addReferenceDataRow.ATF_FILE_SIZE =referenceList.ATF_FILE_SIZE
      addReferenceDataRow.file = referenceList.file ;
      this.dataItems.push(addReferenceDataRow);
      this.referenceSaveItemsParams.data.push(addReferenceDataRow);
    },
    newDialog (item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    openReferenceList () {
      let item =[];
      for(let i=0 ;i< this.ReferenceDataList.header.length;i++){
          item.push(this.ReferenceDataList.header[i]);
      }
        this.$emit('openReferenceFilesList',item);
     },
    browersReferenceFile(e){
      let addReferenceData = {};
      addReferenceData.ATF_FILE_NAME = this.$refs.file.files[0].name;
      addReferenceData.SYSSTATUS = 'I';
      addReferenceData.ADDBY ='LOCAL';
      addReferenceData.CUST_ID = $cookies.get('comp-id');
      addReferenceData.OWNR_CUST_ID = $cookies.get('ownr-id');
      addReferenceData.USER_ID = $cookies.get('user-id');
      addReferenceData.ATF_PRCS_NO = '';
      if (this.caller == 'repository') {
       addReferenceData.SRM_PRCS_NO = this.options.item.REPO_PRCS_NO
      }else{
       addReferenceData.SRM_PRCS_NO = this.options.item.SRM_PRCS_NO
      }
      addReferenceData.FILE_ID = '';
      addReferenceData.ATF_FILE_SIZE = this.$refs.file.files[0].size;
      addReferenceData.file = this.$refs.file.files[0] ;
      addReferenceData.dataId = this.referenceSaveItemsParams.data.length + 1;
      this.dataItems.push(addReferenceData);
      this.referenceSaveItemsParams.data.push(addReferenceData);
    },
    deleteRow(deleteData){
        let browerFlag = true;
        if(deleteData.ADDBY == "LOCAL"){
            browerFlag = false;
            for(let i=0; i< this.referenceSaveItemsParams.data.length;i++){
              if(deleteData.dataId == this.referenceSaveItemsParams.data[i].dataId){
                this.referenceSaveItemsParams.data.splice(i, 1);
              }
            }
            for(let i=0; i< this.dataItems.length;i++){
              if(deleteData.dataId == this.dataItems[i].dataId){
                this.dataItems.splice(i, 1);
              }
            }
        }
        if(browerFlag == true){
        let deleteReference = {};
        deleteReference.ATF_FILE_NAME = deleteData.ATF_FILE_NAME;
        deleteReference.SYSSTATUS = 'D';
        deleteReference.ADDBY ='';
        deleteReference.CUST_ID = $cookies.get('comp-id');
        deleteReference.USER_ID = $cookies.get('user-id');
        deleteReference.ATF_PRCS_NO = deleteData.ATF_PRCS_NO;
        if (this.caller == 'repository') {
        deleteReference.SRM_PRCS_NO = this.options.item.REPO_PRCS_NO
        }else{
          deleteReference.SRM_PRCS_NO = this.options.item.SRM_PRCS_NO
        }
        deleteReference.ATF_FRMT_TP = '';
        deleteReference.FILE_ID = deleteData.FILE_ID;
        deleteReference.ATF_FILE_SIZE = '';
        deleteReference.file = '' ;
        this.referenceSaveItemsParams.data.push(deleteReference);
        let index = this.findIndexItem(deleteData, this.dataItems,'ROWID');
          if (index != null) {
            this.dataItems.splice(index, 1);
          }
        }
    },
    // checkPdfExtension(item) {
    //    let filename = item.ATF_FILE_NAME;
    //    let extension = filename.substr(filename.lastIndexOf('.') + 1);
    //    if (extension == 'pdf') {
    //      return true;
    //    }
    //    return false;
    // },
    downloadReferenceFile(item){
        this.referenceDownloadItems.data[0].FILE_ID = item.FILE_ID;
        this.referenceDownloadItems.data[0].SAVE_NAME = item.ATF_FILE_NAME;
        Store.dispatch("common/DownloadFileFromServer", this.referenceDownloadItems).then(() => {
          console.log("--------- Finished to process ----------");
        });
    },
    // previewPDFFile(item) {
    //     if (item.SYSSTATUS == 'I') {
    //       let blob = item.file;
    //       this.pdfDialog = true;
    //       this.pdfUrl = window.URL.createObjectURL(blob);
    //     } else {
    //       this.referenceDownloadItems.data[0].FILE_ID = item.FILE_ID;
    //       this.referenceDownloadItems.data[0].SAVE_NAME = item.ATF_FILE_NAME;
    //       Store.dispatch("common/GetBlobUrlPDFFile", this.referenceDownloadItems).then(() => {
    //         this.pdfDialog = true;
    //         this.pdfUrl = this.$store.state.common.blobpdffileurl;
    //       });
    //     }
    // },
    saveReferenceFile(){
       console.log(this.referenceModifyItemsParams);
       //203665 apply enable /disable button
       if(this.referenceSaveItemsParams.data.length > 0){
         if (this.flagSave){
           this.referenceModifyItemsParams.data = this.removeDuplicateReferenceModifyItems();
           Store.dispatch("referencefile/modifyReferenceFiles", this.referenceModifyItemsParams).then(() => {
              console.log("--------- Finished to process ----------");
              this.flagSave =false;
          });
        }
        Store.dispatch("srmlist/saveAddReferenceFiles", this.referenceSaveItemsParams).then(() => {
          console.log("--------- Finished to process ----------");
           this.reloadPage = true;
           this.$emit('inputAfterSaveReferenceFiles', {item : this.atftList, selectItem : this.options.item});
           this.$refs.successDialog.dialog = true;
        });
       }
       if (this.flagSave) {
         this.referenceModifyItemsParams.data = this.removeDuplicateReferenceModifyItems();
         Store.dispatch("referencefile/modifyReferenceFiles", this.referenceModifyItemsParams).then(() => {
              console.log("--------- Finished to process ----------");
              this.flagSave =false;
              this.reloadPage = true;
              this.$emit('inputAfterSaveReferenceFiles', {item : this.atftList, selectItem : this.options.item});
              this.$refs.successDialog.dialog = true;
          });
       }
    },
    removeDuplicateReferenceModifyItems(){
       var uniqueArray=[];
       var uniqueReferenceModifyItems=[];
       this.referenceModifyItemsParams.data.reverse();
         for (var i=0; i < this.referenceModifyItemsParams.data.length; i++){
            if (uniqueArray.indexOf(this.referenceModifyItemsParams.data[i].ATF_PRCS_NO) === -1){
              uniqueArray.push(this.referenceModifyItemsParams.data[i].ATF_PRCS_NO);
              uniqueReferenceModifyItems.push(this.referenceModifyItemsParams.data[i]);
            }
          }
       return uniqueReferenceModifyItems;
     },
      findIndexItem(item, arr, col) {
      let prop = (typeof col == 'undefined') ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop]
      })
      return (index > -1) ? index : null
    },
  },

  created() {
    this.queryReferenceFilesList();
    this.getCode();
  },
  watch: {
  },
}
</script>

<style>
.addReferenceFile-layout-dialog {
  min-height: 260px !important;
}
/* .dialog-drag.addReferenceFile-layout-dialog .dialog-body{
  background-color: white;
} */
.dialog-drag.addReferenceFile-layout-dialog .dialog-body .v-card__text.info-section{
  background-color: white;
  height: 20px;
  padding: 0px 21px 0px 0px !important;
  margin-bottom: 10px;
}
.addReferenceFile-layout-dialog .v-card__text.reference-data-section{
  padding: 20px 15px 15px 15px !important;
  background: #FAFCFF;
  border: 1px solid #F0F7FB;
  box-sizing: border-box;
  border-radius: 3px
}
/* .addReferenceFile-layout-dialog .dialog-header{
  background-color: #253C51;
  height: 60px !important;
} */
/* .add-reference-table .v-card__title.headline.white--text{
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 29px;
  display: flex;
  align-items: center;
} */
.add-reference-table{
  background-color: #FFFFFF !important;
  color: black !important;
  height: auto;
}
.add-reference-table thead {
  background: #E4E6E8 !important;
  border: 1px solid #D0D4DD !important;
}
.add-reference-table thead tr th.text-start {
  color: #000000 !important;
  border-right: 1px solid #D0D4DD;
  text-align: center !important;
  height: 25px !important;
}
.add-reference-table td{
  border-right: 1px solid #D0D4DD;
  border-bottom: 1px solid #D0D4DD;
  text-align: center !important;
  padding: 0px 12px 0px 12px !important;
  height: 30px !important;
  font-size: 11px;
}
.add-reference-table td:first-child {
  border-left: 1px solid #D0D4DD;
}
.add-reference-table thead th span {
  font-size: 11px !important;
}
.addReferenceFile-layout-dialog .subheader-text {
  font-weight: bold;
  font-size: 18px;
}
.addReferenceFile-layout-dialog .subheader-message {
  font-weight: bold;
  font-size: 18px;
  color: #ba0070;
}
.add-reference-table .v-data-table__wrapper{
  overflow-y: auto ;
  max-height: 150px ;
  width: 769px ;
}
.btn-add-reference-style{
  width: 60px !important;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px !important;
  line-height: 18px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.4375px;
}
/* .text-custom{
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
} */
.reference-data-section .v-input__control,.reference-data-section .v-select__selections,.reference-data-section .v-select__slot,.reference-data-section .v-input__slot{
  min-height: 16px !important ;
  height: 16px !important;
}
.reference-data-section .v-select__selections{
  height: 16px;
}
.reference-data-section .file-name-col .v-input__slot{
  margin-left: 0px !important;
}
.reference-data-section .v-select__selections .v-select__selection.v-select__selection--comma{
  font-size: 11px !important;
}
.reference-data-section .v-text-field__slot input{
  font-size: 11px !important;
}
.reference-data-section .v-input__append-inner{
  margin-top: 0px !important;
  height: 16px ;
}
.reference-data-section .v-text-field__slot ,.reference-data-section .v-input__icon.v-input__icon--append{
  max-height: 16px !important;
}
.reference-data-section .add-reference-table .document-type-col{
  width:116px;
}
.reference-data-section .add-reference-table .file-name-col{
  width:346px;
}
.add-reference-table .fas.fa-search-plus.theme--light,.add-reference-table .far.fa-arrow-alt-circle-down.theme--light,.add-reference-table .far.fa-trash-alt.theme--light{
  font-size: 14px !important;
  line-height: 17px;
}
.add-reference-table.v-data-table.v-data-table--fixed-header thead th {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
/* Theme Light */
.theme--light .add-reference-table.v-data-table.v-data-table--fixed-header thead th {
  background-color: #E4E6E8 !important;
}
.theme--light .add-reference-table th{
  border-top: 1px solid #D0D4DD;
  border-right: 1px solid #D0D4DD;
  border-bottom: 1px solid #D0D4DD !important;
  font-size: 11px;
  line-height: 15px;
}
.theme--light .add-reference-table th:first-child {
  border-left: 1px solid #D0D4DD;
}
/* Theme Dark */
.theme--dark .add-reference-table.v-data-table {
  background-color: #292C35 !important;
}
.theme--dark .file-name-col .v-text-field.data-table-filter-text-field input {
  color: #FFFFFF !important;
}
.theme--dark .add-reference-table .updated-date-col {
  color: white;
}
.theme--dark .add-reference-table .data-table-select-box .v-input__control .v-input__slot .v-select__selections .v-select__selection {
  color: white;
}
.theme--dark .add-reference-table{
  background-color: #292c35 !important;
  color: #bbbbbb;
}
.theme--dark .add-reference-table table {
  background-color: #191A21 !important;
}
.theme--dark .add-reference-table.v-data-table thead tr:last-child th {
  background-color: #595B64 !important;
  color: white !important;
}
.theme--dark .addReferenceFile-layout-dialog .v-card__text.reference-data-section{
  background: #292C35;
  border: none;
}
.theme--dark .dialog-drag.addReferenceFile-layout-dialog .dialog-body .v-card__text.info-section{
  /* background-color: #3B3E49; */
  background-color: #25272e;
}
.theme--dark .dialog-drag.addReferenceFile-layout-dialog .dialog-body{
  border: none;
  /* background-color: #3B3E49; */
}
</style>
